import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import Fallback from "../fallback";

export default function ErrorBoundaryProvider({ children }) {
    return <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>;
}
